import React, { useState, useEffect } from "react";
import logo from "../assets/images/mta-logo.png";
import "../index.css";

const NavBar = ({
	showNavBar: initialShowNavBar,
	isSubpage: initialIsSubpage,
	pageTitle,
	samePageLinks,
}) => {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [showNavBar, setShowNavBar] = useState(initialShowNavBar);
	const [isSubpage, setIsSubpage] = useState(initialIsSubpage);

	const defaultLinks = [
		{
			id: "introduction",
			title: "Introduction",
			href: "/",
			links: [
				["/#pivotal-moment", "A pivotal moment"],
				["/#our-choice", "Our choice"],
				["/history", "Our history"],
				["/#our-vision", "Our goals"],
				["/#our-plan", "Our plan"],
			],
		},
		{
			id: "rebuild",
			title: "Rebuild",
			href: "rebuild",
			links: [
				["/rebuild#reconstruct", "Reconstruct"],
				["/rebuild#renew", "Renew"],
				["/rebuild#modernize", "Modernize"],
			],
		},
		{
			id: "improve",
			title: "Improve",
			href: "improve",
			links: [
				["/improve#accessibility", "Accessibility"],
				["/improve#resilience", "Resilience"],
				["/improve#sustainability", "Sustainability"],
				["/improve#innovative-tech", "Innovation and technology"],
			],
		},
		{
			id: "expand",
			title: "Expand",
			href: "expand",
			links: [
				["/expand#challenges", "Challenges"],
				["/expand#what-weve-done", "What we've done"],
				["/expand#plan-20year", "Our 20-year plan"],
				["/expand#results", "Results"],
			],
		},
		{
			id: "next-steps",
			title: "Next Steps",
			href: "next-steps",
			links: [
				["/next-steps#new-approach", "A new perspective"],
				["/next-steps#data-driven", "A data-driven approach"],
				["/next-steps#about-plan", "About this plan"],
				["/next-steps#ready-to-deliver", "Ready to deliver"],
				["/next-steps#next-steps", "Keys to success"],
			],
		},
	];

	const setLinks = (defaultLinks) => {
		const newLinks = defaultLinks;
		const currentPath = window.location.pathname;
		const linkDivs = document.querySelectorAll("nav > div > div[id]");
		for (let div of linkDivs) {
			const ul = div.querySelector("ul");
			if (div.id === "introduction") {
				if (
					currentPath !== "/" ||
					currentPath === "/history" ||
					currentPath === "/capitalplan"
				) {
					div.classList.remove("same-page-links");
					ul.classList.remove("same-page-links");
				} else if (currentPath === "/") {
					div.classList.add("same-page-links");
					const linkInfo = newLinks.find(
						(link) => link.id === div.id
					);
					linkInfo.links = samePageLinks;
					ul.classList.add("same-page-links");
					const linkMap = ul.querySelectorAll("li > a");
					for (let link of linkMap) {
						if (
							link.getAttribute("href").substring(1) !== "history"
						) {
							link.onclick = (event) => {
								scrollToSection(event);
								handleButtonClick(!isModalVisible);
							};
						} else if (
							link.getAttribute("href").substring(1) === "history"
						) {
							link.onclick = (event) => {
								event.preventDefault();
								window.location.href = "/history";
							};
						}
					}
				}
			} else {
				if (
					currentPath === "/history" ||
					currentPath === "/capitalplan"
				) {
					div.classList.remove("same-page-links");
					ul.classList.remove("same-page-links");
				} else if (currentPath === `/${div.id}`) {
					div.classList.add("same-page-links");
					const linkInfo = newLinks.find(
						(link) => link.id === div.id
					);
					linkInfo.links = samePageLinks;
					ul.classList.add("same-page-links");
					const linkMap = ul.querySelectorAll("li > a");
					for (let link of linkMap) {
						if (
							link.getAttribute("href").substring(1) !== "history"
						) {
							link.onclick = (event) => {
								scrollToSection(event);
								handleButtonClick(!isModalVisible);
							};
						} else if (
							link.getAttribute("href").substring(1) === "history"
						) {
							link.onclick = (event) => {
								event.preventDefault();
								window.location.href = "/history";
							};
						}
					}
				}
			}
		}
		return newLinks;
	};

	const links = setLinks(defaultLinks);

	const scrollToSection = (event) => {
		event.preventDefault();
		const targetId = event.currentTarget.getAttribute("href").substring(1);
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			window.scrollTo({
				top: targetElement.offsetTop - 40,
				behavior: "smooth",
			});
		}
	};

	const handleButtonClick = (isModalVisible) => {
		const body = document.body;
		const bodyClasses = body.classList;
		if (isModalVisible) {
			bodyClasses.add("menu-opened");
		} else {
			bodyClasses.remove("menu-opened");
		}
		setIsModalVisible(isModalVisible);
	};

	useEffect(() => {
		if (!initialShowNavBar) {
			const handleScroll = () => {
				if (
					window.scrollY >=
					document.documentElement.clientHeight - 80
				) {
					setShowNavBar(true);
				} else {
					setShowNavBar(false);
				}
			};

			window.addEventListener("scroll", handleScroll);
			return () => {
				window.removeEventListener("scroll", handleScroll);
			};
		}
	}, [initialShowNavBar]);

	if (isSubpage) {
		return (
			<header>
				<div id="header-bar">
					<a href="../">
						<img
							src={logo}
							alt="Metropolitan Transportation Authority"
						/>
					</a>
					{pageTitle}
					<button
						onClick={() => handleButtonClick(!isModalVisible)}
						aria-label="Toggle Menu">
						<span className="ada-element">Toggle Menu</span>
						<div className="dot-row">
							<span></span>
							<span></span>
							<span></span>
						</div>
						<div className="dot-row">
							<span></span>
							<span></span>
							<span></span>
						</div>
						<div className="dot-row">
							<span></span>
							<span></span>
							<span></span>
						</div>
					</button>
				</div>
				<nav
					div="row"
					id="menu"
					aria-label="Sitemap, Case Studies and Documents"
					className={isModalVisible ? "menu-opened" : ""}>
					<div className="col-md-9" id="site-map">
						<div id="introduction">
							<h2>
								<a href="/">Introduction</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "introduction")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
						<div id="rebuild">
							<h2>
								<a href="/rebuild">Rebuild</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "rebuild")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
						<div id="improve">
							<h2>
								<a href="/improve">Improve</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "improve")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
						<div id="expand">
							<h2>
								<a href="/expand">Expand</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "expand")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
						<div id="next-steps">
							<h2>
								<a href="/next-steps">Next Steps</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "next-steps")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
					</div>
					<div className="col-md-3" id="mta-resources">
						<div id="case-studies">
							<h2>Downloads</h2>
							<ul>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_Report.pdf"
										target="_blank"
										rel="noreferrer">
										<span>
											20-Year Needs Assessment | Report{" "}
											<em>66MB</em>
										</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_FullAppendix.pdf"
										target="_blank"
										rel="noreferrer">
										<span>
											20-Year Needs Assessment | Appendix{" "}
											<em>144MB</em>
										</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_ReportandAppendix.pdf"
										target="_blank"
										rel="noreferrer">
										<span>
											20-Year Needs Assessment | Report +
											Appendices <em>210MB</em>
										</span>
									</a>
								</li>
								<li>
									<a
										href="https://data.ny.gov/browse?tags=needs%20assessment"
										target="_blank"
										rel="noreferrer">
										<span>Open Data</span>
									</a>
								</li>
								<p>
									<strong>Appendices</strong>
								</p>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_NewYorkCityTransit.pdf"
										target="_blank"
										rel="noreferrer">
										<span>New York City Transit</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_LongIslandRailRoad.pdf"
										target="_blank"
										rel="noreferrer">
										<span>Long Island Rail Road</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_Metro-NorthRailroad.pdf"
										target="_blank"
										rel="noreferrer">
										<span>Metro-North Railroad</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_BridgesandTunnels.pdf"
										target="_blank"
										rel="noreferrer">
										<span>Bridges and Tunnels</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_MTAPolice.pdf"
										target="_blank"
										rel="noreferrer">
										<span>MTA Police</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_ComparativeEvaluation.pdf"
										target="_blank"
										rel="noreferrer">
										<span>Comparative Evaluation</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</header>
		);
	} else {
		return (
			<div id="homepage-menu" className={showNavBar ? "appear" : ""}>
				<div id="header-bar" className={isSubpage ? "scrolled" : ""}>
					<a href="../">
						<img
							src={logo}
							alt="Metropolitan Transportation Authority"
						/>
					</a>
					{pageTitle}
					<button
						onClick={() => handleButtonClick(!isModalVisible)}
						aria-label="Toggle Menu">
						<span className="ada-element">Toggle Menu</span>
						<div className="dot-row">
							<span></span>
							<span></span>
							<span></span>
						</div>
						<div className="dot-row">
							<span></span>
							<span></span>
							<span></span>
						</div>
						<div className="dot-row">
							<span></span>
							<span></span>
							<span></span>
						</div>
					</button>
				</div>
				<nav
					id="menu"
					aria-label="Sitemap, Case Studies and Documents"
					className={isModalVisible ? "menu-opened" : ""}>
					<div className="col-md-9" id="site-map">
						<div className="same-page-links" id="introduction">
							<h2>
								<a href="/">Introduction</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "introduction")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
						<div id="rebuild">
							<h2>
								<a href="rebuild">Rebuild</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "rebuild")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
						<div id="improve">
							<h2>
								<a href="improve">Improve</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "improve")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
						<div id="expand">
							<h2>
								<a href="expand">Expand</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "expand")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
						<div id="next-steps">
							<h2>
								<a href="next-steps">Next Steps</a>
							</h2>
							<ul>
								{links
									.find((link) => link.id === "next-steps")
									.links.map((link, index) => (
										<li key={index}>
											<a href={link[0]}>
												<span>{link[1]}</span>
											</a>
										</li>
									))}
							</ul>
						</div>
					</div>
					<div className="col-md-3" id="mta-resources">
						<div id="case-studies">
							<h2>Downloads</h2>
							<ul>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_Report.pdf"
										target="_blank"
										rel="noreferrer">
										<span>
											20-Year Needs Assessment | Report{" "}
											<em>66MB</em>
										</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_FullAppendix.pdf"
										target="_blank"
										rel="noreferrer">
										<span>
											20-Year Needs Assessment | Appendix{" "}
											<em>144MB</em>
										</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_ReportandAppendix.pdf"
										target="_blank"
										rel="noreferrer">
										<span>
											20-Year Needs Assessment | Report +
											Appendices <em>210MB</em>
										</span>
									</a>
								</li>
								<li>
									<a
										href="./https://data.ny.gov/browse?tags=needs%20assessment"
										target="_blank"
										rel="noreferrer">
										<span>Open Data</span>
									</a>
								</li>
								<p>
									<strong>Appendices</strong>
								</p>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_NewYorkCityTransit.pdf"
										target="_blank"
										rel="noreferrer">
										<span>New York City Transit</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_LongIslandRailRoad.pdf"
										target="_blank"
										rel="noreferrer">
										<span>Long Island Rail Road</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_Metro-NorthRailroad.pdf"
										target="_blank"
										rel="noreferrer">
										<span>Metro-North Railroad</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_BridgesandTunnels.pdf"
										target="_blank"
										rel="noreferrer">
										<span>Bridges and Tunnels</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_MTAPolice.pdf"
										target="_blank"
										rel="noreferrer">
										<span>MTA Police</span>
									</a>
								</li>
								<li>
									<a
										href="https://future.mta.info/documents/20-YearNeedsAssessment_ComparativeEvaluation.pdf"
										target="_blank"
										rel="noreferrer">
										<span>Comparative Evaluation</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</div>
		);
	}
};

export default NavBar;
